// 端内/外
export enum ClientStatus {
  inApp = "0", // 端内
  webApp = "1", // 端外
}
